import React, { useContext } from 'react';
import { graphql } from 'gatsby';

import { Section } from '../../Section';
import { Panel } from '../../Panel';
import { HeroSearch } from '../../search/HeroSearch';
import { Grid } from '../../Grid';
import { CTACard } from '../../CtaCard';
import { SearchCategory } from '../../../types/enums';
import { UiStateContext } from '../../../context/UiStateContext';
import { RequestAValuationBlade } from '../../properties/RequestAValuationBlade';

export const PropertySearch = ({ data: { ctaCard, searchType } }) => {
  const category = searchType?.toLowerCase() === 'rent' ? SearchCategory.Rental : SearchCategory.Resale;
  const { setActiveBlade } = useContext(UiStateContext);

  return (
    <Section contained background="gradient">
      <Grid desktopColumns="2">
        <Panel backgroundColor="white" shadow heading="Find a property" headingComponent="h2">
          <HeroSearch defaultCategory={category} />
        </Panel>
        {ctaCard.button ? (
          <CTACard {...ctaCard} />
        ) : (
          <>
            <CTACard
              title="Need a valuation?"
              lead="Our local agents can provide an accurate valuation for your property."
              backgroundColour="brand"
              shadow
              customButton={{
                label: 'Request a valuation',
                onClick: () => setActiveBlade('propertyRequestAValuation'),
                eventClickBladeId: 'propertyRequestAValuation',
              }}
            />
            <RequestAValuationBlade />
          </>
        )}
      </Grid>
    </Section>
  );
};

export const PropertySearchQuery = graphql`
  fragment PropertySearch on KFH_UmbracoPropertySearchComponentType {
    searchType
    ctaCard {
      ...CtaCard
    }
  }
`;
